import { form } from '../../formState'
import { useTexts } from './useTexts'
import { useValidateDriverEmail } from './useValidateDriverEmail'

export function Email() {
  const texts = useTexts()
  const validateDriverEmail = useValidateDriverEmail()

  form.useAddFieldValidation('email', async (field, _formApi) => {
    const pristine = field.status === 'pristine'
    const initialEmail = _formApi.getInitialValues().email
    const normalizeEmail = (email: string | null | undefined) => (email ?? '').toLowerCase().trim()
    const isOriginalValue = normalizeEmail(field.value) === normalizeEmail(initialEmail)

    const validationResult = await validateDriverEmail(field.value)

    if (validationResult === 'invalid') {
      return texts.error.invalid
    }

    if (validationResult === 'inUse' && !pristine && !isOriginalValue) {
      return texts.error.inUse
    }
  })

  return (
    <form.TextField
      label={texts.label}
      placeholder={texts.placeholder}
      validateOn="blur change"
      name="email"
      testId="email"
    />
  )
}
